import mockInsigthUtils from './mockUtils';

export default {
  facebookInsightsOverviewData(state) {
    return state.facebookPages.reduce((acc, x) => {
      acc[x.id] = mockInsigthUtils.getInsightOverviewData();
      return acc;
    }, {});
  },
  instagramInsightsOverviewData(state) {
    return state.instagramPages.reduce((acc, x) => {
      acc[x.id] = mockInsigthUtils.getInsightOverviewData();
      return acc;
    }, {});
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/social/getters.js